package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class IngredientModel(
    @SerialName("data")
    val  data : Data,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)